export default __webpack_public_path__ + "static/3-693e851c90c61a08604a459940baee58.jpeg";